import { createUseStorageState } from '../createUseStorageState';
var useLocalStorageState = createUseStorageState(typeof window === 'object' ? window.localStorage : null);
export default useLocalStorageState;


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/useLocalStorageState/index.js
// module id = 7496
// module chunks = 2